import { types } from 'actions/sharing_links_actions'

function addLink(links, link) {
  const idx = links.findIndex(l => l.id === link.id)
  if (idx === -1) {
    return [...links, link]
  }
  const newLinks = [...links]
  newLinks[idx] = link
  return newLinks
}

function removeLink(links, id) {
  return links.filter(l => l.id !== id)
}

const initialState = {
  dialogOpened: false,
  currentLink: null,
  successMessage: null,
  errorMessage: null,
  links: []
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.TOGGLE_DIALOG:
      return {
        ...state,
        dialogOpened: action.opened,
        currentLink: action.currentLink,
        successMessage: null,
        errorMessage: null
      }
    case types.LOAD_SHARING_LINKS:
      return {
        ...state,
        links: action.links || []
      }
    case `${types.SAVE_SHARING_LINK}_FAILURE`:
      if (action.error && action.error.response && action.error.response.data && action.error.response.data.errors) {
        return {
          ...state,
          errorMessage: action.error.response.data.errors.join(', ')
        }
      } else {
        return {
          ...state,
          errorMessage: action.error.message
        }
      }
    case types.SAVE_SHARING_LINK:
      return {
        ...state,
        currentLink: action.data.sharing_link,
        successMessage: action.data.message,
        links: addLink(state.links, action.data.sharing_link)
      }
    case `${types.DELETE_SHARING_LINK}_FAILURE`:
      return {
        ...state,
        errorMessage: action.error.message
      }
    case types.DELETE_SHARING_LINK:
      return {
        ...state,
        dialogOpened: false,
        links: removeLink(state.links, action.data.sharing_link.id)
      }
    default:
      return state
  }
}
